import React, {memo} from "react";
import WorkgroupAvatar from "../WorkgroupCol/WorkgroupAvatar";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";


const StationCode = memo(({station, align}) => {
    const alignValue = align === "left" ? "flex-start" : "center";
    return <Stack direction="row" justifyContent={alignValue} alignItems="center">
        <WorkgroupAvatar workgroup={station?.workgroup} size="xs"/>
        <Tooltip title={station?.name} placement="bottom" disableInteractive>
            <span>{station?.code}</span>
        </Tooltip>
    </Stack>
})

export default StationCode;